import { createFileRoute, redirect } from '@tanstack/react-router';
import { Automations } from '~/features/automations/Automations';
import { DocumentTitle } from '~/components/DocumentTitle';
import { NestedRouteErrorBoundary } from '~/components/errors/NestedRouteErrorBoundary';

export const Route = createFileRoute('/_auth/_appLayout/automations')({
  component: AutomationsRoute,
  errorComponent: NestedRouteErrorBoundary,
  loader: async () => {
    // Check if automations are enabled
    const enableAutomations = localStorage.getItem('enableAutomations') === 'true';
    if (!enableAutomations) {
      throw redirect({
        to: '/',
      });
    }
    return {};
  },
});

function AutomationsRoute() {
  return (
    <>
      <DocumentTitle title="Browser Automations | Versori" />
      <Automations />
    </>
  );
}
